type AppointmentOptionType = { value: AppointmentType; label: string };

export const APPOINTMENT_OPTIONS: AppointmentOptionType[] = [
  { value: 'Voluntary administration', label: 'voluntaryAdministration' },
  {
    value: 'Receivership',
    label: 'receivership',
  },
  { value: 'Liquidation', label: 'liquidation' },
  { value: 'Deceased estate', label: 'deceasedEstate' },
  { value: 'Bankruptcy', label: 'bankruptcy' },
  {
    value: 'Director-led sale/recapitalisation',
    label: 'directorLedSaleRecapitalisation',
  },
  { value: 'Other', label: 'other' },
];

export type AppointmentType =
  | 'Voluntary administration'
  | 'Receivership'
  | 'Liquidation'
  | 'Deceased estate'
  | 'Bankruptcy'
  | 'Director-led sale/recapitalisation'
  | 'Other';

export const APPOINTMENT_OPTIONS_TO_ROLE: Record<AppointmentType, string> = {
  'Voluntary administration': 'administrator',
  Receivership: 'receiverAndManager_one',
  Liquidation: 'liquidator',
  'Deceased estate': 'administrator',
  Bankruptcy: 'administrator',
  'Director-led sale/recapitalisation': 'seller',
  Other: 'seller',
} as const;
